module.exports = __webpack_public_path__ + "img/homepage_1@3x.62660b85.jpg";